import React from "react";
import { ReactComponent as InvoiceIcon } from "../../../assets/invoice.svg";
import Button from "../../../component/common/Button";
const EventGuest = ({ setActiveStep }) => {
  return (
    <div className="my-[10px] p-3 sm:p-4 max-w-7xl bg-white rounded-[10px] min-h-[600px]">
      <h1 className="gradient-text font-semibold text-xl">Guest & Invitees</h1>

      <div className="mt-[24px] mb-[17px] pl-0 md:pl-[32px] flex items-center justify-between">
        <h2 className="font-medium text-[#4B4F55]">VIPS</h2>

        <button className="outline-purple-btn rounded-[10px] text-xs xs:text-sm px-[10px] py-2 font-medium border-blue-color text-blue-color flex gap-2 items-center">
          <InvoiceIcon />
          Upload VIP sheet
        </button>
      </div>

      <div className="w-full overflow-x-auto bg-[#F5F6FA] px-4 rounded-[10px] min-h-[331px]">
        <table
          className="table-auto border-separate w-full"
          style={{ borderSpacing: "0 10px" }}
        >
          <thead className="table-text">
            <tr>
              <th className="pt-[20px] pr-5 whitespace-nowrap">
                <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                  Full Name
                </div>
              </th>
              <th className="pt-[20px] pr-5 whitespace-nowrap">
                <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                  Mobile Number
                </div>
              </th>
              <th className="pt-[20px] pr-5 whitespace-nowrap">
                <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                  Email
                </div>
              </th>
              <th className="pt-[20px] pr-5 whitespace-nowrap">
                <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                  Seat Allotment
                </div>
              </th>
              <th className="pt-[20px] pr-5 whitespace-nowrap">
                <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                  Action
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="text-sm divide-y divide-gray-100">
            <tr className="bg-white">
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[15px] sm:pl-[38px] rounded-l-[10px]">
                <div className="flex items-center py-[20px]">
                  <h5 className="table-text pb-0 text-xs sm:text-sm">
                    Augustine Vedmanik
                  </h5>
                </div>
              </td>
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                <div className="flex items-center py-[20px]">
                  <h5 className="table-text pb-0 text-sm">+91 77385 40986</h5>
                </div>
              </td>
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                <div className="flex items-center py-[20px]">
                  <h5 className="table-text pb-0 text-sm">
                    Varun.kubal@gmail.com
                  </h5>
                </div>
              </td>
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                <div className="flex items-center py-[20px]">
                  <h5 className="table-text pb-0 text-sm">Manual</h5>
                </div>
              </td>
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] rounded-r-[10px]">
                <div className="flex items-center py-[20px]">
                  {Array.from({ length: 3 }).map((_, index) => (
                    <div
                      key={index}
                      className="w-[3.5px] h-[3.5px] rounded-full bg-[#030229] mr-[2px]"
                    ></div>
                  ))}
                </div>
              </td>
            </tr>{" "}
            <tr className="bg-white">
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[15px] sm:pl-[38px] rounded-l-[10px]">
                <div className="flex items-center py-[20px]">
                  <h5 className="table-text pb-0 text-xs sm:text-sm">
                    Augustine Vedmanik
                  </h5>
                </div>
              </td>
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                <div className="flex items-center py-[20px]">
                  <h5 className="table-text pb-0 text-sm">+91 77385 40986</h5>
                </div>
              </td>
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                <div className="flex items-center py-[20px]">
                  <h5 className="table-text pb-0 text-sm">
                    Varun.kubal@gmail.com
                  </h5>
                </div>
              </td>
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                <div className="flex items-center py-[20px]">
                  <h5 className="table-text pb-0 text-sm">Manual</h5>
                </div>
              </td>
              <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] rounded-r-[10px]">
                <div className="flex items-center py-[20px]">
                  {Array.from({ length: 3 }).map((_, index) => (
                    <div
                      key={index}
                      className="w-[3.5px] h-[3.5px] rounded-full bg-[#030229] mr-[2px]"
                    ></div>
                  ))}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="border-t border-[#C1CAE1] mt-[16px]">
        <div className="mt-[24px] mb-[17px] pl-0 md:pl-[32px] flex items-center justify-between">
          <h2 className="font-medium text-[#4B4F55]">Invitees</h2>

          <button className="outline-purple-btn rounded-[10px] text-xs xs:text-sm px-[10px] py-2 font-medium border-blue-color text-blue-color flex gap-2 items-center">
            <InvoiceIcon />
            Upload Invitee sheet
          </button>
        </div>
        <div className="w-full overflow-x-auto bg-[#F5F6FA] px-4 rounded-[10px] min-h-[331px]">
          <table
            className="table-auto border-separate w-full"
            style={{ borderSpacing: "0 10px" }}
          >
            <thead className="table-text">
              <tr>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                    Full Name
                  </div>
                </th>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                    Mobile Number
                  </div>
                </th>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                    Email
                  </div>
                </th>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                    Seat Allotment
                  </div>
                </th>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[38px]">
                    Action
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-gray-100">
              <tr className="bg-white">
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[15px] sm:pl-[38px] rounded-l-[10px]">
                  <div className="flex items-center py-[20px]">
                    <h5 className="table-text pb-0 text-xs sm:text-sm">
                      Augustine Vedmanik
                    </h5>
                  </div>
                </td>
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                  <div className="flex items-center py-[20px]">
                    <h5 className="table-text pb-0 text-sm">+91 77385 40986</h5>
                  </div>
                </td>
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                  <div className="flex items-center py-[20px]">
                    <h5 className="table-text pb-0 text-sm">
                      Varun.kubal@gmail.com
                    </h5>
                  </div>
                </td>
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                  <div className="flex items-center py-[20px]">
                    <h5 className="table-text pb-0 text-sm">Manual</h5>
                  </div>
                </td>
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] rounded-r-[10px]">
                  <div className="flex items-center py-[20px]">
                    {Array.from({ length: 3 }).map((_, index) => (
                      <div
                        key={index}
                        className="w-[3.5px] h-[3.5px] rounded-full bg-[#030229] mr-[2px]"
                      ></div>
                    ))}
                  </div>
                </td>
              </tr>
              <tr className="bg-white">
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[15px] sm:pl-[38px] rounded-l-[10px]">
                  <div className="flex items-center py-[20px]">
                    <h5 className="table-text pb-0 text-xs sm:text-sm">
                      Augustine Vedmanik
                    </h5>
                  </div>
                </td>
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                  <div className="flex items-center py-[20px]">
                    <h5 className="table-text pb-0 text-sm">+91 77385 40986</h5>
                  </div>
                </td>
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                  <div className="flex items-center py-[20px]">
                    <h5 className="table-text pb-0 text-sm">
                      Varun.kubal@gmail.com
                    </h5>
                  </div>
                </td>
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] ">
                  <div className="flex items-center py-[20px]">
                    <h5 className="table-text pb-0 text-sm">Manual</h5>
                  </div>
                </td>
                <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] sm:pl-[38px] rounded-r-[10px]">
                  <div className="flex items-center py-[20px]">
                    {Array.from({ length: 3 }).map((_, index) => (
                      <div
                        key={index}
                        className="w-[3.5px] h-[3.5px] rounded-full bg-[#030229] mr-[2px]"
                      ></div>
                    ))}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex justify-center mt-[32px] mb-[18px]">
        <Button
          content="Publish"
          classes="py-[11px] px-[40px] sm:px-[110px] text-sm bg-gradient-to-t from-dark-blue to-[#FFFFFF1F]"
          onClick={() => setActiveStep(6)}
        />
      </div>
    </div>
  );
};

export default EventGuest;
